/**
 * Preenchimento de formulário a partir da consulta pública de CNPJ.
 *
 * Usado pelo cadastro de empresa do superadmin e pela contratação pelo site; os dois
 * formulários usam os mesmos nomes de campo (name, corporateName, phone e endereço).
 */

// CNPJ só com dígitos; a consulta só faz sentido com os 14.
export const normalizeCnpjDigits = (value) => (value || '').replace(/\D/g, '');

/**
 * Copia para o formik os dados devolvidos pela consulta.
 *
 * Só preenche campos que vieram com valor: uma resposta parcial não pode apagar o que a
 * pessoa já digitou. O filtro opcional preserva campos alterados enquanto uma consulta
 * assíncrona estava em andamento. Devolve um aviso quando a situação cadastral não é ATIVA.
 */
export const fillFormFromCnpjLookup = (formik, data, normalizedCnpj, shouldFill = () => true) => {
    const address = data?.address || {};
    const setIfPresent = (field, value) => {
        if (shouldFill(field) && value !== null && value !== undefined && String(value).trim() !== '') {
            formik.setFieldValue(field, value);
        }
    };

    setIfPresent('cnpj', data?.cnpj || normalizedCnpj);
    setIfPresent('name', data?.name);
    setIfPresent('corporateName', data?.corporateName);
    setIfPresent('phone', data?.phone);
    setIfPresent('zipCode', address.zipCode);
    setIfPresent('street', address.street);
    setIfPresent('number', address.number);
    setIfPresent('complement', address.complement);
    setIfPresent('neighborhood', address.neighborhood);
    setIfPresent('city', address.city);
    setIfPresent('state', address.state);

    const status = data?.registrationStatusDescription;
    return status && status !== 'ATIVA' ? `A situação cadastral retornada é: ${status}.` : null;
};
